/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DictionaryInfo } from '../models/dictionary-info';
import { SearchResult } from '../models/search-result';

/**
 * Dictionary Controller
 */
@Injectable({
  providedIn: 'root',
})
class DictionaryControllerService extends __BaseService {
  static readonly pingUsingGET1Path = '/api/dictionary/_ping';
  static readonly dictionariesUsingGETPath = '/api/dictionary/dictionaries';
  static readonly lookUpUsingGETPath = '/api/dictionary/lookup';
  static readonly oneDefinitionUsingGETPath = '/api/dictionary/oneDefinition';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * ping
   * @return OK
   */
  pingUsingGET1Response(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/dictionary/_ping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * ping
   * @return OK
   */
  pingUsingGET1(): __Observable<string> {
    return this.pingUsingGET1Response().pipe(
      __map(_r => _r.body as string)
    );
  }

  /**
   * dictionaries
   * @return OK
   */
  dictionariesUsingGETResponse(): __Observable<__StrictHttpResponse<Array<DictionaryInfo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/dictionary/dictionaries`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<DictionaryInfo>>;
      })
    );
  }
  /**
   * dictionaries
   * @return OK
   */
  dictionariesUsingGET(): __Observable<Array<DictionaryInfo>> {
    return this.dictionariesUsingGETResponse().pipe(
      __map(_r => _r.body as Array<DictionaryInfo>)
    );
  }

  /**
   * lookUp
   * @param params The `DictionaryControllerService.LookUpUsingGETParams` containing the following parameters:
   *
   * - `word`: word
   *
   * - `userId`: userId
   *
   * @return OK
   */
  lookUpUsingGETResponse(params: DictionaryControllerService.LookUpUsingGETParams): __Observable<__StrictHttpResponse<SearchResult>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.word != null) __params = __params.set('word', params.word.toString());
    if (params.userId != null) __params = __params.set('userId', params.userId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/dictionary/lookup`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SearchResult>;
      })
    );
  }
  /**
   * lookUp
   * @param params The `DictionaryControllerService.LookUpUsingGETParams` containing the following parameters:
   *
   * - `word`: word
   *
   * - `userId`: userId
   *
   * @return OK
   */
  lookUpUsingGET(params: DictionaryControllerService.LookUpUsingGETParams): __Observable<SearchResult> {
    return this.lookUpUsingGETResponse(params).pipe(
      __map(_r => _r.body as SearchResult)
    );
  }

  /**
   * oneDefinition
   * @return OK
   */
  oneDefinitionUsingGETResponse(): __Observable<__StrictHttpResponse<string>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/dictionary/oneDefinition`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<string>;
      })
    );
  }
  /**
   * oneDefinition
   * @return OK
   */
  oneDefinitionUsingGET(): __Observable<string> {
    return this.oneDefinitionUsingGETResponse().pipe(
      __map(_r => _r.body as string)
    );
  }
}

module DictionaryControllerService {

  /**
   * Parameters for lookUpUsingGET
   */
  export interface LookUpUsingGETParams {

    /**
     * word
     */
    word?: string;

    /**
     * userId
     */
    userId?: number;
  }
}

export { DictionaryControllerService }
